import React, { useState } from "react";
import Layout from "../../components/common/Layout";
import { ADMIN_NAV, LEAD_NAV, EMPLOYEE_NAV } from "../../utils/navigation";
import { useAuth } from "../../context/AuthContext";
import { db } from "../../firebase/config";
import { collection, query, where, getDocs } from "firebase/firestore";
import { Link } from "react-router-dom";

export default function TravelReimbursement() {
  const { userProfile, currentUser } = useAuth();
  const [myClaims, setMyClaims] = useState([]);
  const [loadingClaims, setLoadingClaims] = useState(false);
  const [historyOpened, setHistoryOpened] = useState(false);

  const navItems = userProfile?.role === "admin" ? ADMIN_NAV :
                   userProfile?.role === "lead" ? LEAD_NAV : EMPLOYEE_NAV;

  const fetchClaims = async () => {
    if (!currentUser?.uid) return;
    setLoadingClaims(true);
    try {
      // Use only where() — no orderBy() — to avoid requiring a composite
      // Firestore index. Sort client-side instead.
      const q = query(
        collection(db, "reimbursements"),
        where("userId", "==", currentUser.uid)
      );
      const snap = await getDocs(q);
      const docs = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      // Sort by submittedAt descending (client-side)
      docs.sort((a, b) => {
        const ta = a.submittedAt?.toMillis?.() ?? 0;
        const tb = b.submittedAt?.toMillis?.() ?? 0;
        return tb - ta;
      });
      setMyClaims(docs);
    } catch (e) {
      console.error("Error fetching claims", e);
    }
    setLoadingClaims(false);
  };

  const handleViewHistory = () => {
    setHistoryOpened(true);
    fetchClaims();
  };

  const handleCloseHistory = () => {
    setHistoryOpened(false);
  };

  return (
    <Layout navItems={navItems} panelLabel="My Portal">
      <div className="page-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h1 className="page-title">Travel Reimbursements</h1>
        <div style={{ display: "flex", gap: 10 }}>
          {!historyOpened && (
            <button
              onClick={handleViewHistory}
              className="btn-success-sm"
              style={{ padding: "8px 16px", fontSize: "14px", cursor: "pointer" }}
            >
              View Claim History
            </button>
          )}
          <Link
            to="/travel-reimbursement/new"
            className="btn-success-sm"
            style={{ textDecoration: "none", padding: "8px 16px", fontSize: "14px" }}
          >
            + Create New Claim
          </Link>
        </div>
      </div>

      {historyOpened && (
        <div style={{ marginTop: "24px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
            <h3 style={{ margin: 0, fontSize: 15, fontWeight: 700, color: "#164231" }}>Claim History</h3>
            <button
              onClick={handleCloseHistory}
              title="Close"
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                fontSize: 20,
                lineHeight: 1,
                color: "#64748B",
                padding: "2px 8px",
                borderRadius: 6,
              }}
            >
              ×
            </button>
          </div>
          <div className="data-table-wrap">
            {loadingClaims ? (
              <div className="card-loading">Loading your claims...</div>
            ) : myClaims.length === 0 ? (
              <div className="card-empty">You have no submitted claims.</div>
            ) : (
              <table className="data-table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Total Amount</th>
                    <th>Advance</th>
                    <th>Reimbursement</th>
                  </tr>
                </thead>
                <tbody>
                  {myClaims.map(c => (
                    <tr key={c.id}>
                      <td>{c.date}</td>
                      <td>₹{parseFloat(c.grandTotal + (c.advance || 0)).toFixed(2)}</td>
                      <td>₹{parseFloat(c.advance || 0).toFixed(2)}</td>
                      <td><strong>₹{parseFloat(c.grandTotal || 0).toFixed(2)}</strong></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      )}
    </Layout>
  );
}